/**
 * Sprogsider — ukrainsk indhold (/uk).
 *
 * REGLER: ingen priser eller varigheder skrives her — de hentes fra courseGroups.js.
 * Hver faktuel påstand skal kunne føres tilbage til `sources`.
 */

const FS = (label, path) => ({ label, url: `https://www.fstyr.dk${path}` });

const AUTHORITY = "Данське управління дорожнього руху (Færdselsstyrelsen)";

export const uk = {
  code: "uk",
  htmlLang: "uk",
  dir: "ltr",
  locale: "uk_UA",
  numLocale: "uk-UA",
  nativeName: "Українська",
  currency: "DKK",
  ui: {
    notice:
      "Ця сторінка українською. Решта сайту votra.dk, данською. Телефонуйте на +45 55 29 28 28, і ми допоможемо вам українською.",
    indexTitle: "Транспортні курси українською в Данії | Votra",
    indexDescription:
      "Курс перевізника (vognmand) для вантажівки та фургона: самостійне навчання, екзамен у Votra з перекладачем, кваліфікація водія фургона, українською.",
    indexH1: "Транспортні курси українською",
    indexIntro:
      "Votra Danmark ApS, данський навчальний центр у сфері транспорту з головним офісом у Сьоборзі (Søborg) та екзаменаційним центром у Рінґстеді (Ringsted). Ми внесені до списку Данського управління дорожнього руху (Færdselsstyrelsen) як затверджений провайдер екзамену для перевізників вантажів, і ми надаємо перекладача на екзамені, якщо ви складаєте його українською, англійською або арабською.",
    coursesHeading: "Курси, які можна скласти українською",
    openCourse: "Докладніше",
    answerHeading: "Коротка відповідь",
    facts: {
      heading: "Основні факти",
      course: "Курс",
      provider: "Провайдер",
      delivery: "Як це працює",
      duration: "Тривалість",
      priceDa: "Ціна, екзамен данською",
      priceForeign: "Ціна, українською (перекладач включений)",
      priceAmu: "Ціна AMU (якщо ви маєте право)",
      venue: "Де",
      certificate: "Що ви отримуєте",
      entry: "Вимоги до вступу",
      authority: "Компетентний орган",
    },
    dates: {
      headingExam: "Найближчі дати екзаменів",
      headingCourse: "Найближчі дати курсів",
      empty: "Зараз немає опублікованих дат. Зателефонуйте нам, і ми знайдемо для вас дату.",
      seats: "вільних місць",
      full: "Місць немає",
      signUp: "Записатися",
      language: "Мова",
      languages: { da: "данська", en: "англійська", ar: "арабська", uk: "українська", fa: "перська" },
      allInLanguage: "Переглянути всі дати з перекладом українською",
      calendarNotice: "Ви бачите лише дати, коли цей курс проводиться з перекладом українською.",
      calendarNoticeAll: "Ви бачите лише дати, коли доступний переклад українською.",
      calendarBack: "Повернутися до українських сторінок",
    },
    faqHeading: "Питання та відповіді",
    sourcesHeading: "Офіційні джерела",
    cta: {
      heading: "Готові почати?",
      text: "Зателефонуйте нам, ми відповімо на ваші питання українською, або напишіть нам на e-mail, і ми зв'яжемося з вами.",
      call: "Телефонуйте +45 55 29 28 28",
      email: "Написати нам",
      signUpForm: "Заповнити форму запису",
      danishPage: "Повна сторінка курсу данською",
    },
    danishRequiredBadge: "Данська мова, законна вимога для цього курсу",
    fvuCta: "Подивіться підготовку до данської у Votra (FVU, рівень 2)",
    backHome: "Votra данською",
    otherLangs: "Інші мови",
    breadcrumb: "Українська",
  },
  courses: {
    "haulier-truck": {
      slug: "ліцензія-перевізника-вантажівка",
      metaTitle: "Курс перевізника для вантажівки українською | Votra",
      metaDescription:
        "Стати затвердженим транспортним менеджером для вантажівок понад 3 500 кг. Самостійне навчання онлайн, екзамен у Votra, перекладач, три спроби.",
      h1: "Курс перевізника для вантажівки (godsvognmand), українською",
      short: "Керуйте вантажною транспортною компанією з вантажівками понад 3 500 кг. Самостійне навчання + екзамен у Votra.",
      answer:
        "Данська кваліфікація перевізника вантажів (godsvognmandsuddannelsen) дає право бути затвердженим транспортним менеджером у компанії, яка має ліцензію на перевезення вантажів за винагороду вантажівкою або автопоїздом понад 3 500 кг. У Votra ви навчаєтеся онлайн у власному темпі, а потім складаєте письмовий екзамен у нас: Votra Danmark ApS внесена до списку затверджених провайдерів екзамену Færdselsstyrelsen. Ціна включає екзамен із трьома спробами, а при складанні українською ми надаємо перекладача.",
      facts: {
        course: "Кваліфікація перевізника вантажів для вантажівки (godsvognmandsuddannelsen)",
        delivery: "Самостійне навчання з онлайн-матеріалами + письмовий екзамен у Votra",
        duration: "Самостійне навчання у власному темпі. Законна вимога: щонайменше 144 заняття по 60 хвилин",
        venue: "Екзамен у Votra в Рінґстеді (Sct. Hansgade 9, 2-й поверх) та Сьоборзі",
        certificate: "Свідоцтво про професійну компетентність у вантажних перевезеннях, основа для затвердження транспортним менеджером",
        entry: "Вік від 18 років і вміння працювати з електронними таблицями (наприклад, Excel)",
        authority: AUTHORITY,
      },
      sections: [
        {
          h2: "Як проходить курс",
          paragraphs: [
            "Аудиторних занять немає. Ви отримуєте доступ до онлайн-матеріалів, які охоплюють усі теми додатка 1 до данської постанови про вантажні перевезення (bekendtgørelsen om godskørsel), читаєте їх, коли вам зручно, а потім складаєте екзамен у вибрану вами дату.",
            "Законна вимога: курс має охоплювати щонайменше 144 заняття по 60 хвилин, включно з перервою до 15 хвилин. Саме такий обсяг покривають матеріали, але темп визначаєте ви, і обов'язкової присутності немає.",
          ],
        },
        {
          h2: "Екзамен",
          paragraphs: [
            "Екзамен письмовий. Його готує та організовує Færdselsstyrelsen, і він складається в електронній екзаменаційній системі управління. Оскільки Votra є затвердженим провайдером екзамену, ви складаєте його в нашому власному приміщенні в Рінґстеді або Сьоборзі, не в третьої сторони.",
            "Екзамен складається з 60 питань із вибором відповіді та 6 практичних кейсів; для складання потрібно 65 % від усього екзамену. Три спроби включені в ціну курсу, і ми реєструємо вас на екзамен.",
            "Якщо ви складаєте екзамен українською, Votra надає перекладача. Саме тому ціна мовою, іншою за данську, вища.",
          ],
        },
        {
          h2: "Що охоплює екзамен",
          paragraphs: [
            "Усі 11 тематичних блоків додатка 1: цивільне право, комерційне право, трудове та соціальне законодавство, податкове законодавство, комерційне та фінансове управління підприємством, доступ до ринку, технічні норми й експлуатація, безпека дорожнього руху, діяльність із надання водіїв, техніка переговорів і управління безпекою руху.",
            "Повний перелік із усіма підпунктами опубліковано на данській сторінці курсу, це офіційна програма, а не маркетинговий список.",
          ],
        },
        {
          h2: "Після успішного складання",
          paragraphs: [
            "Свідоцтво покриває вимогу професійної компетентності. Перед видачею ліцензії Færdselsstyrelsen компанія також має відповідати вимогам щодо наявності офісу, фінансової спроможності (вимога до капіталу), оплати та умов праці й доброї репутації, і призначити затвердженого транспортного менеджера.",
            "Збір становить 1 500 DKK за ліцензію Спільноти та 1 500 DKK за кожну засвідчену копію; ліцензія видається на строк до 10 років, а рішення управління очікується протягом 60 днів.",
          ],
        },
      ],
      faq: [
        { q: "Чи можу я скласти екзамен українською?", a: "Так. Votra надає перекладача при складанні екзамену українською, англійською або арабською. Перекладач включений у ціну для мов, інших за данську." },
        { q: "Чи є аудиторні заняття?", a: "Ні. Ви вивчаєте онлайн-матеріали у власному темпі, а потім складаєте екзамен у Votra. Обов'язкової присутності та фіксованої дати початку немає." },
        { q: "Яка структура екзамену?", a: "60 питань із вибором відповіді та 6 практичних кейсів. Для складання потрібно 65 % від усього екзамену. Екзамен письмовий і проходить в електронній системі Færdselsstyrelsen у приміщенні Votra." },
        { q: "Скільки спроб я маю?", a: "Три спроби включені в ціну курсу." },
        { q: "Де проходить екзамен?", a: "У Votra в Рінґстеді (Sct. Hansgade 9, 2-й поверх) або в Сьоборзі. Votra Danmark ApS внесена до списку затверджених провайдерів екзамену для перевізників вантажів." },
        { q: "Які вимоги до вступу?", a: "Вам має бути щонайменше 18 років і треба вміти працювати з електронними таблицями, наприклад Excel, бо фінансова частина розраховується в таблиці." },
        { q: "Чи потрібні права на вантажівку?", a: "Ні. Кваліфікація перевізника стосується управління транспортним бізнесом. Водійське посвідчення та підготовка водія, вимоги до того, хто керує автомобілем, а не до транспортного менеджера." },
        { q: "Чи достатньо свідоцтва, щоб отримати ліцензію?", a: "Ні. Воно покриває професійну компетентність. Компанія також має відповідати вимогам щодо офісу, фінансової спроможності, оплати та умов праці й доброї репутації." },
      ],
      sources: [
        FS("Екзамени для перевізників вантажів, Votra у списку провайдерів", "/privat/chauffoeruddannelser/uddannelser-i-godskoersel/proever-for-godsvognmaend"),
        FS("Про вантажні перевезення (Færdselsstyrelsen)", "/erhverv/gods/om-godskoersel"),
        { label: "Постанова про вантажні перевезення, додаток 1", url: "https://www.retsinformation.dk/eli/lta/2018/1222" },
      ],
    },

    "haulier-van": {
      slug: "ліцензія-перевізника-фургон",
      metaTitle: "Курс перевізника для фургона українською | Votra",
      metaDescription:
        "Право на ліцензію для перевезення вантажів фургонами від 2 500 до 3 500 кг. Самостійне навчання онлайн, екзамен у Votra, перекладач.",
      h1: "Курс перевізника для фургона (vognmand til varebil), українською",
      short: "Керуйте вантажною транспортною компанією з фургонами від 2 500 до 3 500 кг. Самостійне навчання + екзамен у Votra.",
      answer:
        "Кваліфікація перевізника для фургона дає змогу подати заяву на ліцензію для перевезення вантажів за винагороду фургоном або автопоїздом із дозволеною максимальною масою від 2 500 кг до 3 500 кг. У Votra ви навчаєтеся онлайн у власному темпі, а потім складаєте письмовий екзамен у нас у Рінґстеді або Сьоборзі. Ціна включає екзамен із трьома спробами, а при складанні українською ми надаємо перекладача.",
      facts: {
        course: "Кваліфікація перевізника для фургона (vognmandsuddannelsen til varebil)",
        delivery: "Самостійне навчання з онлайн-матеріалами + письмовий екзамен у Votra",
        duration: "Самостійне навчання у власному темпі. Законна вимога: щонайменше 37 занять по 60 хвилин",
        venue: "Екзамен у Votra в Рінґстеді (Sct. Hansgade 9, 2-й поверх) та Сьоборзі",
        certificate: "Свідоцтво про професійну компетентність для перевезень фургоном, основа для ліцензії",
        entry: "Вік від 18 років і вміння працювати з електронними таблицями (наприклад, Excel)",
        authority: AUTHORITY,
      },
      sections: [
        {
          h2: "Як проходить курс",
          paragraphs: [
            "Ні аудиторних занять, ні фіксованої дати початку. Ви отримуєте онлайн-матеріали, які охоплюють усі теми додатка 2 до постанови про вантажні перевезення, і складаєте екзамен у вибрану вами дату.",
            "Законна вимога до курсу, щонайменше 37 занять по 60 хвилин, включно з перервою до 15 хвилин.",
          ],
        },
        {
          h2: "Екзамен",
          paragraphs: [
            "Екзамен письмовий, його готує Færdselsstyrelsen, і він складається в електронній екзаменаційній системі управління. Votra проводить екзамен у власному приміщенні в Рінґстеді та Сьоборзі й реєструє вас на нього.",
            "Це екзамен із вибором відповіді, який складається на комп'ютері, і для складання потрібно щонайменше 76 % правильних відповідей. Кількість питань визначає Færdselsstyrelsen, і її повідомляють під час реєстрації. Три спроби включені в ціну.",
            "Якщо ви складаєте екзамен українською, Votra надає перекладача, саме тому ціна мовою, іншою за данську, вища.",
          ],
        },
        {
          h2: "Фургон чи вантажівка, що саме вам потрібно?",
          paragraphs: [
            "Кваліфікація для фургона охоплює перевезення вантажів фургонами від 2 500 до 3 500 кг і вимагає щонайменше 37 занять (додаток 2). Якщо ви хочете перевозити вантажі вантажівкою або автопоїздом понад 3 500 кг, потрібна кваліфікація для вантажівки, де вимога, щонайменше 144 заняття (додаток 1). Ці дві ліцензії не замінюють одна одну.",
          ],
        },
      ],
      faq: [
        { q: "Чи можу я скласти екзамен українською?", a: "Так. Votra надає перекладача при складанні екзамену українською, англійською або арабською. Він включений у ціну для мов, інших за данську." },
        { q: "Яка структура екзамену?", a: "Це екзамен із вибором відповіді на комп'ютері, проходний бал, 76 % правильних відповідей. Кількість питань визначає Færdselsstyrelsen і повідомляє під час реєстрації. Три спроби включені." },
        { q: "Чи є аудиторні заняття?", a: "Ні. Ви навчаєтеся онлайн у власному темпі, а потім складаєте екзамен у Votra. Без обов'язкової присутності та фіксованої дати початку." },
        { q: "Які масові обмеження охоплює ліцензія для фургона?", a: "Фургони та автопоїзди з дозволеною максимальною масою від 2 500 кг до 3 500 кг. Понад це потрібна кваліфікація для вантажівки." },
        { q: "Де проходить екзамен?", a: "У Votra в Рінґстеді (Sct. Hansgade 9, 2-й поверх) та в Сьоборзі." },
        { q: "Які вимоги до вступу?", a: "Вам має бути щонайменше 18 років і треба вміти працювати з електронними таблицями, наприклад Excel." },
        { q: "Чи достатньо свідоцтва, щоб отримати ліцензію?", a: "Ні. Færdselsstyrelsen також вимагає наявності офісу, фінансової спроможності, належної оплати та умов праці й доброї репутації до видачі ліцензії." },
      ],
      sources: [
        FS("Фургони, правила комерційних вантажних перевезень", "/erhverv/varebil"),
        FS("Кваліфікації для фургона (Færdselsstyrelsen)", "/privat/chauffoeruddannelser/varebilsuddannelser"),
        { label: "Постанова про вантажні перевезення, додаток 2", url: "https://www.retsinformation.dk/eli/lta/2018/1222" },
      ],
    },

    "van-driver-basic": {
      slug: "кваліфікація-водія-фургона",
      metaTitle: "Кваліфікація водія фургона (VB GU) українською | Votra",
      metaDescription:
        "Обов'язкова базова кваліфікація для водіїв фургонів, які перевозять вантажі за винагороду. Дає свідоцтво водія фургона, дійсне п'ять років.",
      h1: "Базова кваліфікація водія фургона (VB GU), українською",
      short: "Обов'язкове свідоцтво для комерційного керування фургоном. Три дні, екзамен включений.",
      answer:
        "VB GU, це обов'язкова базова кваліфікація для водіїв, які перевозять вантажі за винагороду фургоном. Вона дає данське свідоцтво водія фургона (varebilschaufføruddannelsesbevis), яке потрібно мати при собі під час руху та показувати на вимогу поліції. Вимога діє, якщо ви перевозите вантаж за винагороду вагою понад 11 кг за одне місце у фургоні або автопоїзді з дозволеною максимальною масою від 2 500 кг до 3 500 кг.",
      facts: {
        course: "Базова кваліфікація водія фургона (VB GU)",
        delivery: "Аудиторний курс разом із нашим партнером UCplus, завершується письмовим екзаменом",
        duration: "3 дні",
        venue: "UCplus Сковлунде (Mileparken 12A), приміщення нашого партнера",
        certificate: "Свідоцтво кваліфікації водія фургона (VUB), як правило дійсне п'ять років",
        entry: "Немає. Жодних попередніх умов для участі",
        authority: AUTHORITY,
      },
      sections: [
        {
          h2: "Кому це потрібно?",
          paragraphs: [
            "Водіям, які перевозять вантажі за винагороду фургоном, де вантаж важить понад 11 кг за одне місце, а дозволена максимальна маса фургона чи автопоїзда становить від 2 500 кг до 3 500 кг.",
            "Якщо ви вже маєте синю карту кваліфікації водія для категорії C (вантажівка), ви автоматично маєте ті самі права, що й власники свідоцтва водія фургона.",
          ],
        },
        {
          h2: "Екзамен",
          paragraphs: [
            "Базова кваліфікація завершується письмовим екзаменом із 20 питань із вибором відповіді, де правильна лише одна. Для складання потрібно щонайменше 16 правильних відповідей, 76 %, і ви маєте 30 хвилин. Кандидатам із документально підтвердженою дислексією надають 45 хвилин.",
          ],
        },
        {
          h2: "Строк дії та поновлення",
          paragraphs: [
            "Свідоцтво, як правило, дійсне п'ять років. Щоб його зберегти, потрібно пройти дводенний курс підвищення кваліфікації, на якому екзамену немає. Продовжувати комерційні перевезення фургоном до завершення цього курсу не можна.",
            "Зверніть увагу: VB означає varebil, тобто фургон. Це не має жодного відношення до автобусів.",
          ],
        },
      ],
      faq: [
        { q: "Чи VB GU, це курс для автобусів?", a: "Ні. VB означає varebil, що данською означає фургон. VB GU, курс для фургона." },
        { q: "Чи є екзамен і яка його структура?", a: "Так. 20 питань із вибором відповіді за 30 хвилин, і для складання потрібно щонайменше 16 правильних відповідей (76 %). За документально підтвердженої дислексії надають 45 хвилин." },
        { q: "Скільки діє свідоцтво?", a: "Як правило п'ять років. Після цього потрібен дводенний курс підвищення кваліфікації (VB EU)." },
        { q: "Чи є вимоги до вступу?", a: "Ні. Жодних попередніх умов для участі немає." },
        { q: "Чи можу я пройти курс українською?", a: "Так, ми проводимо курс українською, англійською та арабською, а також данською, але доступні мови різняться залежно від дати. Телефонуйте на +45 55 29 28 28, і ми скажемо, що доступно." },
      ],
      sources: [FS("Кваліфікації для фургона (Færdselsstyrelsen)", "/privat/chauffoeruddannelser/varebilsuddannelser")],
    },

    "van-driver-refresher": {
      slug: "перепідготовка-водія-фургона",
      metaTitle: "Курс VB EU для водія фургона українською | Votra",
      metaDescription:
        "Дводенний курс, який поновлює данське свідоцтво водія фургона. Без екзамену.",
      h1: "Курс підвищення кваліфікації водія фургона (VB EU), українською",
      short: "Поновіть свідоцтво водія фургона за два дні. Без екзамену.",
      answer:
        "VB EU, обов'язковий курс підвищення кваліфікації, який поновлює данське свідоцтво водія фургона (varebilschaufføruddannelsesbevis). Курс триває два дні, екзамену немає. Якщо строк дії вашого свідоцтва закінчився, продовжувати комерційні перевезення фургоном до завершення курсу не можна.",
      facts: {
        course: "Курс підвищення кваліфікації водія фургона (VB EU)",
        delivery: "Аудиторний курс разом із нашим партнером UCplus. Без екзамену",
        duration: "2 дні",
        venue: "UCplus Сковлунде (Mileparken 12A), приміщення нашого партнера",
        certificate: "Поновлене свідоцтво кваліфікації водія фургона (VUB)",
        entry: "Свідоцтво кваліфікації водія фургона (VUB)",
        authority: AUTHORITY,
      },
      sections: [
        {
          h2: "Коли він потрібен?",
          paragraphs: [
            "Свідоцтво, як правило, дійсне п'ять років. До закінчення строку ви проходите дводенний курс, і свідоцтво поновлюється. Екзамену на курсі немає.",
            "Якщо ви не впевнені щодо свого терміну, зателефонуйте нам, ми допоможемо знайти відповідну дату.",
          ],
        },
      ],
      faq: [
        { q: "Чи є екзамен?", a: "Ні. На курсі підвищення кваліфікації екзамену немає." },
        { q: "Що потрібно для участі?", a: "Свідоцтво кваліфікації водія фургона. Якщо строк його дії закінчився, потрібно пройти дводенний курс, перш ніж відновити комерційні перевезення." },
        { q: "Чи VB EU, це курс для автобусів?", a: "Ні. VB означає varebil, фургон." },
        { q: "Чи можу я пройти курс українською?", a: "Так, ми проводимо його українською, англійською та арабською, а також данською, але доступні мови різняться залежно від дати. Телефонуйте на +45 55 29 28 28." },
      ],
      sources: [FS("Кваліфікації для фургона (Færdselsstyrelsen)", "/privat/chauffoeruddannelser/varebilsuddannelser")],
    },

    "taxi-driver": {
      slug: "водій-таксі-в-данії",
      danishRequired: true,
      metaTitle: "Водій таксі в Данії: вимога данської мови | Votra",
      metaDescription:
        "Данський курс водія таксі можна пройти лише данською: закон вимагає рівня Prøve i Dansk 2. Що кажуть правила і як підготуватися.",
      h1: "Стати водієм таксі в Данії, прочитайте це спершу",
      short: "Важливо: курс таксі не можна пройти українською. Данська на рівні Prøve i Dansk 2, законна вимога.",
      answer:
        "Важливо: данський курс кваліфікації водія таксі не можна пройти українською, англійською або арабською. Закон вимагає володіння данською на рівні, що відповідає Prøve i Dansk 2, перш ніж вас можуть зарахувати на затверджений курс. Ми кажемо це відразу, щоб ви не платили за курс, на який вас не можуть зарахувати. Усе інше, вік, водійське посвідчення, курс і два екзамени, описано нижче.",
      facts: {
        course: "Курс кваліфікації водія таксі (taxi-kvalifikationsuddannelsen)",
        delivery: "Аудиторні заняття, індивідуальні уроки з керування та два екзамени. Лише данською",
        duration: "Щонайменше 74 години, у тому числі не менше 6 індивідуальних уроків із керування",
        venue: "Votra Рінґстед (Sct. Hansgade 9, 2-й поверх), у списку затверджених провайдерів Færdselsstyrelsen",
        certificate: "Основа для картки водія (chaufførkort), яку видає Færdselsstyrelsen",
        entry: "Данська на рівні Prøve i Dansk 2, 21 рік на момент підсумкових екзаменів, посвідчення категорії B щонайменше 3 роки, затверджена медична довідка та добра репутація",
        authority: AUTHORITY,
      },
      sections: [
        {
          h2: "Мовна вимога, це вимога закону",
          paragraphs: [
            "Зарахування на затверджений курс кваліфікації водія таксі вимагає володіння данською на рівні, що відповідає Prøve i Dansk 2, як передбачено додатком 4 до данської постанови про таксі (taxibekendtgørelsen). На практиці це підтверджується свідоцтвом Prøve i Dansk 2 або екзаменом з данської мови за 9-й клас данської школи.",
            "Це не правило Votra. Жоден затверджений провайдер у Данії не може зарахувати вас без цього, а рішення про відмову в зарахуванні через недостатнє знання данської не можна оскаржити в Færdselsstyrelsen.",
          ],
        },
        {
          h2: "Інші вимоги",
          paragraphs: [
            "Вам має бути щонайменше 21 рік на момент складання підсумкових екзаменів і ви маєте мати посвідчення категорії B щонайменше 3 роки, періоди, коли посвідчення було вилучено, не враховуються. Курс має тривати щонайменше 74 години, включно з не менш як 6 індивідуальними уроками з керування, і завершується теоретичним екзаменом та практичним екзаменом з керування.",
            "Теоретичний екзамен складається з 30 питань із вибором відповіді за 45 хвилин, і для складання потрібно щонайменше 23 правильні відповіді. Практичний екзамен проходить в автомобілі й оцінюється затвердженим інструктором категорії B із зовнішнім оцінюванням інструктора з іншого затвердженого центру.",
            "Саму картку водія видає Færdselsstyrelsen, яка також оцінює ваш стан здоров'я (вимоги групи 2: зір, слух та інше) і добру репутацію. Збір за картку становить 1 700 DKK, а медична довідка зазвичай коштує 750 DKK.",
          ],
        },
        {
          h2: "Як підготувати свою данську",
          paragraphs: [
            "Votra також пропонує підготовку до FVU з данської, рівень 2, із ШІ-репетитором, який пояснює 12 мовами, читає текст уголос і дає реалістичні тренувальні тести. Це добрий спосіб посилити письмову та усну данську.",
            "Зверніть увагу: FVU з данської рівня 2 і Prøve i Dansk 2, це два різні екзамени. Телефонуйте на +45 55 29 28 28, і ми допоможемо визначити, який шлях швидше приведе вас до курсу таксі.",
          ],
        },
        {
          h2: "Курси, які можна пройти українською, англійською або арабською",
          paragraphs: [
            "Якщо ваша мета, працювати в транспорті вже зараз, кваліфікації перевізника для вантажівки та фургона доступні з перекладачем на екзамені. Вони дають право керувати транспортною компанією, і в них немає вимоги щодо данської мови, яка є в курсі таксі.",
          ],
        },
      ],
      faq: [
        { q: "Чи можу я пройти курс таксі українською?", a: "Ні. Зарахування на затверджений курс кваліфікації водія таксі вимагає данської на рівні, що відповідає Prøve i Dansk 2. Ця вимога встановлена данською постановою про таксі, а не Votra." },
        { q: "Як підтвердити знання данської?", a: "Як правило, свідоцтвом Prøve i Dansk 2 або екзаменом з данської мови за 9-й клас данської школи." },
        { q: "Що ще потрібно?", a: "Вам має бути 21 рік на момент підсумкових екзаменів, мати посвідчення категорії B щонайменше 3 роки, скласти теоретичний і практичний екзамени та відповідати вимогам Færdselsstyrelsen щодо здоров'я (група 2) і доброї репутації." },
        { q: "Яка структура теоретичного екзамену?", a: "30 питань із вибором відповіді за 45 хвилин. Для складання потрібно щонайменше 23 правильні відповіді. Практичний екзамен оцінюється як складений або не складений." },
        { q: "Скільки коштує картка водія?", a: "1 700 DKK, збір до Færdselsstyrelsen. Медична довідка зазвичай коштує 750 DKK. Ціна курсу окремо." },
        { q: "Які курси Votra я можу пройти без данської?", a: "Кваліфікації перевізника для вантажівки та фургона, а також курси водія фургона VB GU і VB EU. Votra надає перекладача на екзамені українською, англійською та арабською." },
      ],
      sources: [
        FS("Курс кваліфікації водія таксі (Færdselsstyrelsen)", "/privat/chauffoeruddannelser/taxi-kvalifikationsuddannelsen"),
        FS("Вимоги до картки водія", "/erhverv/taxi/taxichauffoerer/krav-til-chauffoerkort"),
        { label: "Данська постанова про таксі (BEK № 1244 від 26.11.2019)", url: "https://www.retsinformation.dk/eli/lta/2019/1244" },
      ],
    },
  },
};

export default uk;
